import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SharedModule } from '../../shared/shared.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnauthComponent } from './unauth/unauth.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { SupportInstantComponent } from './support-instant/support-instant.component';
import { RegisterBusinessComponent } from './register-business/register-business.component';
import { MigrateComponent } from 'src/app/layouts/migrate/migrate.component';
import { VerificationComponent } from '../misc/verification/verification.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { ScanUploadComponent } from '../misc/scan-upload/scan-upload.component';
import { ProjectionCalculatorComponent } from './projection-calculator/projection-calculator.component';
import { HighchartsChartModule } from 'highcharts-angular';

import { CustomerLandingPageComponent } from './customer-landing-page/customer-landing-page.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    HighchartsChartModule
  ],
  declarations: [
    LoginComponent,
    VerificationComponent,
    MigrateComponent,
    ForgotPasswordComponent,
    NotFoundComponent,
    UnauthComponent,
    NewPasswordComponent,
    SupportInstantComponent,
    RegisterBusinessComponent,
    MaintenanceComponent,
    ScanUploadComponent,
    ProjectionCalculatorComponent,
    CustomerLandingPageComponent
  ],
  exports: [
    LoginComponent,
    VerificationComponent,
    ForgotPasswordComponent,
    SupportInstantComponent,
    ScanUploadComponent
  ]
})
export class PublicModule { }